import { render, staticRenderFns } from "./ep_color.vue?vue&type=template&id=e75b4b6a&scoped=true"
import script from "./ep_color.vue?vue&type=script&lang=js"
export * from "./ep_color.vue?vue&type=script&lang=js"
import style0 from "./ep_color.vue?vue&type=style&index=0&id=e75b4b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75b4b6a",
  null
  
)

export default component.exports